'use strict';

export default {
  name: 'ToastMixin',

  methods: {
    showError(message) {
      const notification = {
        duration: -1,
        icon: 'mdi-alert-octagon',
        iconColor: '#F35',
        message,
        sticky: true
      };
      this.$root.$emit('notify-user', notification);
    },
    showInfo(message) {
      const notification = {
        duration: 3000,
        icon: 'mdi-information-outline',
        iconColor: '#0AF',
        message,
        sticky: false
      };
      this.$root.$emit('notify-user', notification);
    },
    showSuccess(message) {
      const notification = {
        duration: 3000,
        icon: 'mdi-checkbox-marked-circle-outline',
        iconColor: '#0A0',
        message,
        sticky: false
      };
      this.$root.$emit('notify-user', notification);
    },
    showWarning(message) {
      const notification = {
        duration: 3000,
        icon: 'mdi-alert',
        iconColor: '#FB2',
        message,
        sticky: false
      };
      this.$root.$emit('notify-user', notification);
    }
  }
};
